import { render, staticRenderFns } from "./error-message.vue?vue&type=template&id=b9a4d97c&"
import script from "./error-message.ts?vue&type=script&lang=ts&"
export * from "./error-message.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports